export const types = {
  SET_DISTRICT_ID: 'timesheetSubmissionProcessor/SET_DISTRICT_ID',
};

export const setDistrictId = (districtId) => {
  return {
    type: types.SET_DISTRICT_ID,
    districtId,
  };
};
